<template>
    <div ref="wrapping-container" style="position: relative;" class="is--editor">
        <div v-if="! isLoading"
             :style="{ width: (30 * viewport.factor) + 'px', position: 'relative', margin: 'auto' }"
             style="z-index: 2;clear: both;">
            <div class="body" :style="{ height: (30 * viewport.factor) + 'px', position: 'relative' }">
                <div class="h-rule"  v-if="'cake-topper' !== baseColorClassName" v-for="triggerPoint in viewport.trigger" :style="triggerLine(triggerPoint.line)">
                    <span class="label">{{ triggerPoint.label }} {{ triggerPoint.indicator }}</span>
                </div>

                <template v-if="preloadActive">
                    <div class="preloading-images-indicator">
                        <img
                            src="/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/loading.svg"
                            alt="Loading"
                        >
                    </div>
                </template>
                <template v-else>
                    <button v-if="0 === plexipeople.length" class="is--uploader" @click="openUploader">
                        <i data-v-63411e51="" class="icon-upload2"></i>
                        <span>Foto Upload</span>
                    </button>

                    <vue-draggable-resizable
                        v-for="(entry, key) in plexipeople"
                        :key="entry.uuid"
                        :x="entry.x"
                        :y="(30 * viewport.factor) - entry.height"
                        :w="entry.width"
                        :h="entry.height"
                        :aspect="true"
                        :parent="true"
                        :handles="['tm']"
                        :plexipeople="entry"
                        :style="{ 'background-image': 'url(' + entry.extraction.source + ')', 'z-index': (entry.active ? 9999 : entry.groove * 1000 + key) }"
                        :active="entry.active"
                        axis="xb"
                        @activated="activated"
                        @deactivated="deactivated"
                        @resizestop="resized"
                        @dragstop="dragged"
                    />
                </template>
            </div>

            <div class="footer"
                 :class="[baseColorClass, 'size-'+base.width.value]"
                 :style="{ width: ((base.width.value / 10) * viewport.factor) + 'px', height: ((base.height.value / 10) * viewport.factor) + 'px'}"
                 v-if="'none' !== base.color.class && 'cake-topper' !== base.color.class">
              <span class="is--label" v-if="'none' !== baseColorClassName">{{ base.width.label }}</span>

              <div class="sockel--wrapper">
                <div class="sockel"
                     :class="[baseColorClass, 'nut-'+base.grooves.value]"
                     :style="{ width: ((base.width.value / 10) * viewport.factor) + 'px', height: ((base.height.value / 10) * viewport.factor * 1.75) + 'px'}">
                  <div class="imgHolder cornerLeft">
                      <img :src="'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/'+base.color.class+'/grooves-'+base.grooves.value+'_left.png'" alt="">
                  </div>
                  <div class="imgHolder cornerRight">
                      <img :src="'/custom/plugins/NetiPlexipeopleLeonardo/Resources/frontend/img/foot/'+base.color.class+'/grooves-'+base.grooves.value+'_right.png'" alt="">
                  </div>
                </div>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "../event-bus";
    import VueDraggableResizable from "./DraggableResizeable";

    export default {
        data() {
            return {
                baseWidthCollection: App.configuration.variants.widths.elements,
                baseColorClassName: this.base.color.class,
                resizeOffsetTimeout: false,
                timeoutResizeFunction: false,
                maxEditorWidth: 600,
            };
        },

        computed: {
            baseColorClass() {
                return 'is--' + this.base.color.class;
            },
        },

        props: {
            editInPlace: Boolean,
            viewport: Object,
            base: Object,
            plexipeople: Array,
            isLoading: {
                type: Boolean,
                default: true,
            },
            preloadActive: {
                type: Boolean,
                default: false,
            },
        },

        watch: {
            plexipeople() {
                let vm             = this,
                    imagePreloader = [];

                if (0 === vm.plexipeople.length) {
                    return;
                }

                vm.preloadActive = true;

                vm.plexipeople.forEach((entry) => {
                    imagePreloader.push(new Promise((resolve, reject) => {
                        let image = new Image();

                        image.addEventListener('load', () => {
                            resolve();
                        });

                        image.src = entry.extraction.source;
                    }));
                });

                Promise.all(imagePreloader).then(() => {
                    window.setTimeout(() => {
                        vm.preloadActive = false;
                        vm.$emit("preloaderDone");
                    }, 1000);
                });
            },
        },

        methods: {
            openUploader() {
                EventBus.$emit('navigation_triggerUploadButton');
            },

            handleDown: function(e) {
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
            },

            triggerLine(line) {
                if ('portrait' === this.viewport.format) {
                    return {
                        width: line.width,
                        height: line.height
                    };
                }

                // noinspection JSSuspiciousNameCombination
                return {
                    width: line.height,
                    height: line.width
                };
            },

            activated(vm) {
                vm.plexipeople.active = true;

                this.$emit('activated', vm.plexipeople);
            },

            deactivated(vm) {
                vm.plexipeople.active = false;

                this.$emit('deactivated', vm.plexipeople);
            },

            resized(x, y, width, height, vm) {
                let maxHeight = 30 * this.viewport.factor,
                    maxWidth  = 30 * this.viewport.factor;

                vm.plexipeople.x = x;

                if (height > maxHeight) {
                    height    = maxHeight;
                    vm.height = maxHeight;
                }

                window.setTimeout(() => {
                    vm.y             = maxHeight - height;
                    vm.top           = maxHeight - height;
                    vm.plexipeople.y = maxHeight - height;

                    if (1 === this.plexipeople.length) {
                        vm.elmX = vm.x = vm.plexipeople.x = ((maxWidth - vm.width) / 2);
                    }
                }, 100);

                vm.plexipeople.width  = width;
                vm.plexipeople.height = height;

                EventBus.$emit('calculatePrices');
            },

            dragged(x, y, vm) {
                let maxHeight = 30 * this.viewport.factor;

                y = maxHeight - vm.height;

                vm.plexipeople.x = x;
                vm.y             = y;
                vm.plexipeople.y = y;
            },

            toggleGroove(plexipeople) {
                plexipeople.groove = (plexipeople.groove % this.base.grooves.value) + 1;

                EventBus.$emit('calculatePrices');
            },

            setBaseColor(colorItem) {
                this.baseColorClassName = colorItem.class;
                this.baseColorClass     = 'is--' + colorItem.class;
            },

            resetGrooveOnAllPlexipeople(groove) {
                this.plexipeople.forEach((plexipeople) => {
                    if (plexipeople.groove > groove.value) {
                        plexipeople.groove = groove.value;
                    }
                });

                EventBus.$emit('calculatePrices');
            },

            closeModal() {
                let vm = this;

                //@TODO: Ω make dynamic
                vm.$modal.hide('preview');

                window.setTimeout(() => {
                  vm.previewImage = '';
                }, 100);
            },

            viewportResized() {
                let oldFactor = this.viewport.factor,
                    newFactor = (this.$refs['wrapping-container'].offsetWidth - (2 * 20)) / 30;

                if (this.maxEditorWidth < 30 * newFactor) {
                    newFactor = this.maxEditorWidth / 30;
                }

                this.viewport.factor = newFactor;

                this.$emit('viewportFactorChanged', this.viewport.factor);

                this.plexipeople.forEach((plexipeople) => {
                    plexipeople.width  = (plexipeople.width / oldFactor) * newFactor;
                    plexipeople.height = (plexipeople.height / oldFactor) * newFactor;
                    plexipeople.x      = (plexipeople.x / oldFactor) * newFactor;
                });
            },
        },

        components: {
            VueDraggableResizable
        },

        created() {
            let vm = this;

            vm.timeoutResizeFunction = (values) => {
                if (vm.resizeOffsetTimeout) {
                    window.clearTimeout(vm.resizeOffsetTimeout);
                }

                vm.resizeOffsetTimeout = window.setTimeout(() => {
                    vm.viewportResized.call(vm, values);
                }, 500);
            };

            EventBus.$on('resized', vm.timeoutResizeFunction);
        },

        mounted() {
            let vm = this;

            vm.viewportResized();

            vm.$emit("mounted");

            EventBus.$on('colorChanged', vm.setBaseColor);
            EventBus.$on('groovesChanged', vm.resetGrooveOnAllPlexipeople);
        },

        beforeDestroy() {
            EventBus.$off('colorChanged', this.setBaseColor);
            EventBus.$off('groovesChanged', this.resetGrooveOnAllPlexipeople);
            EventBus.$off('resized', this.timeoutResizeFunction);
        }
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/components/editor";

    .preloading-images-indicator {
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        top: 0;

        img {
            width: 120px;
            height: 120px;
        }
    }

    .base--footer {
        .is--width-indicator {
            position: absolute;
            height: 100%;
            left: 0;
            right: 0;
            margin: 0 auto;
            border-left: 1px black dashed;
            border-right: 1px black dashed;

            .is--label {
                position: absolute;
                bottom: 5px;
                right: 5px;
                font-size: smaller;
                font-weight: 600;
            }
        }
    }

    .footer {
        .is--label {
            position: absolute;
            bottom: 5px;
            right: 8px;
            font-size: smaller;
            font-weight: 600;
            color: #fff;
        }

      &.is--white {
        .is--label {
          color: #6b6b6b;
        }
      }
    }
</style>



// WEBPACK FOOTER //
// src/components/Editor.vue